import { render } from "./ChangeVehicleForm.vue?vue&type=template&id=1359c8d3"
import script from "./ChangeVehicleForm.vue?vue&type=script&lang=js"
export * from "./ChangeVehicleForm.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ChangeVehicleForm.vue?vue&type=style&index=0&id=1359c8d3&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/driver/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__